<body [class.bg-dark]="isDark" [class.text-light]="isDark">
    
<div class="container-fluid" #containerFluid [class.dark-theme]="isDark" [class.embedded]="embedded">
    <!-- Controles de zoom para escala de precios -->

  <div class="row d-flex fw-semibold content-row" [class.text-light]="isDark" [class.main-color]="!isDark">
    <!-- ── Toolbar de drawing tools estilo TradingView (compartida) ── -->
    <app-drawing-toolbar class="col-auto p-0 drawing-toolbar-host" [controller]="drawingCtl"></app-drawing-toolbar>

    <div class="chart-column col">

      <!-- ── Barra superior estilo TradingView ── -->
      <div class="chart-topbar" [class.dark]="isDark" [class.wrap]="expandir">

        <!-- ⓪ Selector de activos — solo en modo embebido (dentro de Models) -->
        <ng-container *ngIf="embedded">
          <!-- Selector de modelo — solo con varios modelos (Portfolio Labs con varias carteras) -->
          <ng-container *ngIf="modelosLista.length > 1">
            <ng-select class="asset-selector-topbar" [items]="modelosLista"
              bindLabel="nombre" bindValue="idmodelo"
              [(ngModel)]="selectedModeloId"
              [clearable]="false" [searchable]="true"
              placeholder="Modelo"
              (change)="onModeloSelectorChange()">
            </ng-select>
            <div class="topbar-sep"></div>
          </ng-container>
          <ng-select class="asset-selector-topbar" [items]="companias"
            bindLabel="iso" bindValue="idNectum"
            [(ngModel)]="selectedCompanyId"
            [clearable]="false" [searchable]="true"
            placeholder="Activo"
            (change)="onAssetSelectorChange()">
          </ng-select>
          <div class="topbar-sep"></div>
        </ng-container>

        <!-- ① Marco temporal: sólo D activo, el resto visual — solo en modo "grafica" (no embebido, no modelo) -->
        <ng-container *ngIf="!isModelo && !embedded">
          <button *ngFor="let tf of timeframes"
            class="btn-topbar"
            [class.active]="activeTimeframe === tf"
            [class.tf-disabled]="tf !== 'D'"
            (click)="setTimeframe(tf)"
            [disabled]="periodoBloqueado"
            [title]="periodoBloqueado ? 'Periodo bloqueado por modelo' : (tf !== 'D' ? tf + ' — próximamente' : 'Diario')">
            {{ tf }}
          </button>

          <div class="topbar-sep"></div>
        </ng-container>

        <!-- ② Tipo de vela -->
        <div class="ind-anchor">
          <button class="btn-topbar" [class.active]="showCandleDropdown"
            (click)="showCandleDropdown=!showCandleDropdown; $event.stopPropagation()"
            [title]="chartType" style="gap:5px;">
            <i [ngClass]="[chartTypeIcon, 'icon-base']"></i>
            <i class="bi bi-chevron-down icon-xs" style="opacity:.6;"></i>
          </button>
          <div class="ind-panel candle-panel" *ngIf="showCandleDropdown" [class.dark]="isDark"
            (click)="$event.stopPropagation()">
            <a class="candle-item" (click)="setChartType('candlestick'); showCandleDropdown=false">
              <i class="bi bi-graph-up"></i> Velas japonesas
            </a>
            <a class="candle-item" (click)="setChartType('heikin-ashi'); showCandleDropdown=false">
              <i class="bi bi-columns-gap"></i> Heikin Ashi
            </a>
            <a class="candle-item" (click)="setChartType('bar'); showCandleDropdown=false">
              <i class="bi bi-bar-chart"></i> Barras OHLC
            </a>
            <hr style="margin:4px 8px; border-color: rgba(128,128,128,.3);">
            <a class="candle-item" (click)="setChartType('line'); showCandleDropdown=false">
              <i class="bi bi-graph-up-arrow"></i> Línea
            </a>
            <a class="candle-item" (click)="setChartType('area'); showCandleDropdown=false">
              <i class="bi bi-triangle-fill"></i> Área
            </a>
            <a class="candle-item" (click)="setChartType('baseline'); showCandleDropdown=false">
              <i class="bi bi-subtract"></i> Línea base
            </a>
          </div>
        </div>

        <div class="topbar-sep"></div>

        <!-- ③ Indicadores — ancla del panel flotante -->
        <div class="ind-anchor">
            <button class="btn-topbar" [class.active]="showIndicatorsPanel"
            (click)="toggleIndicatorsPanel()">
            <i class="bi bi-activity icon-base"></i>
            <span>Indicadores</span>
            <span class="badge-active" *ngIf="getIndicatorKeys().length">
              {{ getIndicatorKeys().length }}
            </span>
          </button>

          <!-- Panel flotante -->
          <div class="ind-panel" *ngIf="showIndicatorsPanel" [class.dark]="isDark">

            <div class="ind-header">
              <div class="ind-search-wrap">
                <i class="bi bi-search ind-search-icon"></i>
                <input class="ind-search-input" type="text" [(ngModel)]="indicatorSearch"
                  placeholder="Buscar indicador..." autocomplete="off">
              </div>
              <button class="ind-close-btn" (click)="toggleIndicatorsPanel()">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>

            <div class="ind-body">

              <!-- En gráfico -->
              <div class="ind-section" *ngIf="getIndicatorKeys().length">
                <div class="ind-section-title">
                  <i class="bi bi-check-circle-fill icon-sm" style="color:#26a69a;"></i>
                  En gráfico
                </div>
                <div *ngFor="let key of getIndicatorKeys()" class="ind-row">
                  <i class="bi bi-activity ind-row-icon"></i>
                  <span class="ind-row-name" [title]="key">{{ key }}</span>
                  <button class="ind-icon-btn" (click)="toggleIndicatorSeries(key)"
                    [title]="isIndicatorVisible(key) ? 'Ocultar' : 'Mostrar'">
                    <i class="bi" [class.bi-eye-fill]="isIndicatorVisible(key)"
                       [class.bi-eye-slash]="!isIndicatorVisible(key)"></i>
                  </button>
                  <button class="ind-icon-btn danger" (click)="removeIndicatorFromChart(key)" title="Eliminar">
                    <i class="bi bi-trash3"></i>
                  </button>
                </div>
              </div>

              <div class="ind-divider" *ngIf="getIndicatorKeys().length"></div>

              <!-- Catálogo técnico -->
              <div class="ind-section">
                <div class="ind-section-title">
                  <i class="bi bi-bar-chart-line icon-sm"></i>
                  Técnicos disponibles ({{ indicatorCatalog.length }})
                </div>
                <div class="ind-empty" *ngIf="indicatorSearch && !filteredAvailableIndicators.length">
                  Sin resultados para "<strong>{{ indicatorSearch }}</strong>"
                </div>
                <div *ngFor="let ind of filteredAvailableIndicators" class="ind-row"
                  [class.ind-row-added]="isIndicatorInChart(ind.id)">
                  <i class="bi ind-row-icon icon-base"
                     [class.bi-check-circle-fill]="isIndicatorInChart(ind.id)"
                     [class.bi-graph-up-arrow]="!isIndicatorInChart(ind.id)"
                     [class.muted]="!isIndicatorInChart(ind.id)"
                     [style.color]="isIndicatorInChart(ind.id) ? '#26a69a' : null"></i>
                  <span class="ind-row-name" [title]="ind.title">
                    <span style="font-weight:600;">{{ ind.short }}</span>
                    <span style="color:#888; margin-left:4px;" class="txt-sm">{{ ind.title }}</span>
                  </span>
                  <button *ngIf="!isIndicatorInChart(ind.id)" class="ind-icon-btn add"
                    (click)="addIndicatorToChart(ind)"
                    [disabled]="isAddingIndicator(ind.id)"
                    [title]="isAddingIndicator(ind.id) ? 'Calculando...' : 'Añadir al gráfico'">
                    <i class="bi"
                       [class.bi-plus-lg]="!isAddingIndicator(ind.id)"
                       [class.bi-hourglass-split]="isAddingIndicator(ind.id)"></i>
                  </button>
                  <button *ngIf="isIndicatorInChart(ind.id)" class="ind-icon-btn danger"
                    (click)="removeIndicatorFromChart(ind.id)" title="Eliminar">
                    <i class="bi bi-trash3"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="topbar-sep"></div>

        <!-- ④ Presets de rango -->
        <button *ngFor="let r of ranges"
          class="btn-topbar"
          [class.active]="activeRange === r"
          (click)="setZoomRange(r)"
          [disabled]="rangeLoading"
          [title]="rangeLoading ? 'Cargando histórico…' : (noMoreOlderHistoryReached ? 'No hay más historial disponible más atrás' : null)">
          {{ r }}
        </button>

        <!-- ⑤ Ver Data — alineado a la derecha -->
        <ng-container *ngIf="isModelo">
          <div class="topbar-sep" style="margin-left:auto;"></div>
          <mat-slide-toggle style="font-size:11px;" [class.text-light]="isDark"
            (change)="onSlideToggleChange($event)">Ver Data
          </mat-slide-toggle>
        </ng-container>

        <!-- ⑥ Estado de mercado — badge compacto al extremo derecho -->
        <ng-container *ngIf="marketCountdownText">
          <div class="topbar-sep" [style.margin-left]="isModelo ? null : 'auto'"></div>
          <div class="market-countdown" [ngClass]="{'market-open': isMarketOpen, 'market-closed': !isMarketOpen}">
            <span class="market-name">{{ marketDisplayName }}</span>
            <span class="status">{{ isMarketOpen ? 'Abierto' : 'Cerrado' }}</span>
            <span class="separator">·</span>
            <span class="countdown">{{ marketCountdownText }}</span>
            <span class="timezone" *ngIf="marketTimezone">({{ marketTimezone }})</span>
          </div>
        </ng-container>

      </div>

      <!-- ── Stack del gráfico ── -->
      <div id="chartStack" class="chart-stack">
        <!-- Indicador de carga mientras se piden velas (fetch inicial + chunks al hacer scroll/zoom) -->
        <div class="velas-loading" *ngIf="cargandoVelas" [class.dark]="isDark">
          <span class="velas-loading-spinner"></span>
          <span class="velas-loading-text">Cargando velas…</span>
        </div>
        <div id="container" #container class="chart-layer chart-candles" style="position:absolute; inset:0;"></div>
        <div id="overlayContainer" class="chart-layer chart-overlays" style="position:absolute; inset:0; pointer-events: none;"></div>
        <!-- Toolbar flotante del dibujo seleccionado + árbol de objetos -->
        <app-drawing-floating-toolbar [controller]="drawingCtl"></app-drawing-floating-toolbar>
        <app-drawing-object-tree [controller]="drawingCtl"></app-drawing-object-tree>
        <!-- Overlays apilados top-left: OHLC, leyenda de indicadores, condición del modelo -->
        <div class="chart-overlay-stack">
        <app-chart-legend
          [symbolLabel]="nombreCompania"
          [timeframeLabel]="activeTimeframe"
          [crosshairOhlc]="crosshairOhlc"
          [legendItems]="legendItems"
          [isDark]="isDark">
        </app-chart-legend>
        <!-- Condición del modelo — overlay semi-transparente, lista de condiciones (top-left, debajo de la leyenda) -->
        <div class="condicion-legend" [class.dark]="isDark" *ngIf="condicionEntradaLista.length || condicionSalidaLista.length">
          <div class="condicion-legend-title">Condición</div>
          <div class="condicion-legend-row" *ngFor="let texto of condicionEntradaLista">
            <span class="condicion-legend-tipo entrada">Entrada</span>
            <span class="condicion-legend-text">{{ texto }}</span>
          </div>
          <div class="condicion-legend-row" *ngFor="let texto of condicionSalidaLista">
            <span class="condicion-legend-tipo salida">Salida</span>
            <span class="condicion-legend-text">{{ texto }}</span>
          </div>
        </div>
        <!-- Período bajo el cursor (hover), modo embebido — mismos datos que "Análisis Periodos" -->
        <div class="periodo-legend" [class.dark]="isDark" *ngIf="hoveredPeriodoLegend">
          <div class="periodo-legend-title">
            Período {{ hoveredPeriodoLegend.contadorAnalizados }}: {{ hoveredPeriodoLegend.fechaInicio }} → {{ hoveredPeriodoLegend.fechaFin }}
          </div>
          <table class="periodo-legend-table">
            <tr>
              <td></td>
              <td>Inicio</td>
              <td>Fin</td>
              <td>%</td>
            </tr>
            <tr>
              <td>Vol Histórica</td>
              <td>{{ hoveredPeriodoLegend.vHistoricoI | number:'1.2-2' }}</td>
              <td>{{ hoveredPeriodoLegend.vHistoricoF | number:'1.2-2' }}</td>
              <td>{{ hoveredPeriodoLegend.vHistorico | number:'1.2-2' }}</td>
            </tr>
            <tr>
              <td>Vol Relativa</td>
              <td>{{ hoveredPeriodoLegend.vRelativaI | number:'1.2-2' }}</td>
              <td>{{ hoveredPeriodoLegend.vRelativaF | number:'1.2-2' }}</td>
              <td>{{ hoveredPeriodoLegend.vRelativa | number:'1.2-2' }}</td>
            </tr>
            <tr>
              <td>Desv estándar</td>
              <td>{{ hoveredPeriodoLegend.desviacionStandardI | number:'1.2-2' }}</td>
              <td>{{ hoveredPeriodoLegend.desviacionStandardF | number:'1.2-2' }}</td>
              <td>{{ hoveredPeriodoLegend.desviacionStandard | number:'1.2-2' }}</td>
            </tr>
            <tr>
              <td>Vol. Mercado</td>
              <td>{{ hoveredPeriodoLegend.valorVolatilidadFI }}</td>
              <td>{{ hoveredPeriodoLegend.valorVolatilidadFF }}</td>
              <td></td>
            </tr>
            <tr>
              <td>Valores</td>
              <td>{{ hoveredPeriodoLegend.valorFinFI }}</td>
              <td>{{ hoveredPeriodoLegend.valorFinFF }}</td>
              <td></td>
            </tr>
            <tr>
              <td>Rango Fin</td>
              <td></td>
              <td></td>
              <td>{{ hoveredPeriodoLegend.periodosRangoMayorFin }}{{ hoveredPeriodoLegend.periodosRangoMenorFin }}</td>
            </tr>
          </table>
        </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 table-panel" *ngIf="expandir">
           <div class="row align-items-center justify-content-between mb-2 table-panel-header">
             <h4 class="col-auto mb-0 table-panel-title" [class.text-light]="isDark">Analisis de Operativa ({{ descripcionRowsCount }})</h4>
             <a class="col-auto table-panel-link" target="_blank" href="/models?id={{idmodelo}}">
               Ver Modelo
               <i class="bi bi-box-arrow-up-right ms-1" title="Abrir en otra ventana"></i>
             </a>
           </div>
           <cdk-virtual-scroll-viewport [appendOnly]="false"  [tvsItemSize]="24" [headerHeight]="34"  #viewportValLat id="viewportValLat" class="wrapper2 mat-elevation-z2">
                <div *ngIf="descripcionRowsCount === 0" class="px-3 py-2" [class.text-light]="isDark">Sin registros para mostrar.</div>
                <table cdk-table [dataSource]="dataAdicional" class="table-striped operativa-table">
            
                  <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsLat; sticky: true" class="sticky-header"></tr>
                  <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsLat;" (click)="selectRow(row)"
                      [ngClass]="{'selected': row === filaSeleccionada, 'salida': row.isSalida, 'entrada': row.isEntrada}"></tr>
                  <ng-container *ngFor="let tablecol of tableColumnsLat">

                    <ng-container [cdkColumnDef]="tablecol.id">
                      <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
                        {{tablecol.name}}
                      </th>
                      <td cdk-cell *cdkCellDef="let item" [ngSwitch]="tablecol.id" [ngClass]="{
                                                      'numero-positivo': tablecol.id !== 'tipo' && tablecol.id !== 'fecha' && item[tablecol.id] > 0,
                                                      'numero-negativo': tablecol.id !== 'tipo' && tablecol.id !== 'fecha' && item[tablecol.id] < 0
                                                      }">
                        <!-- Fecha compacta: dd/MM/yy + hora atenuada si aplica -->
                        <span class="cell-fecha" *ngSwitchCase="'fecha'">
                          {{ item.fecha | date:'dd/MM/yy' }}
                          <span class="cell-hora" *ngIf="hasTimeOfDay(item.fecha)">{{ item.fecha | date:'HH:mm' }}</span>
                        </span>
                        <!-- Tipo como badge de color -->
                        <span class="tipo-badge" *ngSwitchCase="'tipo'" [ngClass]="tipoClass(item)" [title]="item.tipo">
                          {{ tipoLabel(item) }}
                        </span>
                        <!-- Resto de columnas (valores numéricos / indicador) -->
                        <ng-container *ngSwitchDefault>
                          <span [title]="item[tablecol.id]">
                            {{ (item[tablecol.id] === 0 || item[tablecol.id] === '') ? '—' : (item[tablecol.id] | separarValores) }}
                          </span>
                        </ng-container>
                      </td>
                    </ng-container>
                  </ng-container>
                </table>
              </cdk-virtual-scroll-viewport>
        </div>
    </div>
</div>
</body>




